import { defineAction, object } from '~/prix'
import communityDeleteAction from './geoCommunityDelete.action.json' with { type: 'json' }
// import { z } from 'zod'
// import { dateOrIsoString } from '~/prix/types/date'

const communityDeleteDefinition = defineAction({
  ...communityDeleteAction,

  // input: z.object({
  //   id: z.string(),
  //   updatedAt: dateOrIsoString().nullish(),
  // }),
  // output: z.object({}),

  input: object<any>({}),
  output: object<any>({}),
})

export default communityDeleteDefinition
